/* eslint-disable no-console,no-undef,camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import { withTranslation } from 'react-i18next';
import Select from 'react-select';
import timezones from '../../../../timezones.json';
import {
  Layout,
  // Container,
  InputContainer,
  StyledInputV2,
  StyledLabel,
  ButtonContainer,
  CustomRadioButton,
  Locationwrapper,
  EditorContainer,
  SearchDropDown,
  // MUICalendarWrapper,
  InitiativeIcon,
  CustomRadioButtonV1,
} from '../LaunchCompanyInitiative/style';
import {Container} from "../../CreateEvent/style";
// import { LocalizationProvider } from '@mui/x-date-pickers';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
// import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';
import { TitleContainer } from '../../AdminTeamCreation/styles';
import { Main } from '../../AdminTeamCreation/styles';
import { Border } from '../../Journeys/styles';
import { ManagerIconContainer } from '../../Manager/styles';
import { Heading } from '../../RecogntionAdmin/corevalues/styles';
import { CommonButtonPopup } from '../styles';
import CommonButton from '../../common/CommonButton/CommonButton';
import CommonDropdown from '../../common/CommonDropDown/CommonDropdown';
import Editor from '../../CKEditor';
import StepNames from '../../RecogntionAdmin/corevalues/stepNames';
import LazyImage from '../../common/LazyImage/LazyImage';
import { NewDropDownIcon, RecognitionTickIcon, RecognitionCloseIcon, CalendarBranding,/* NewCalendarIcon, NewCalendarIconDisabled*/ } from '../../../utils/icons';
import { ImageUrl } from '../../../utils/constants';
import { fetchApi, checkBase64 } from '../../../utils/methods';
import CommonImageUploader from '../../common/CommonImageUploader/CommonImageUploader';
import { getCompanyLocation, getCompanyDepartment } from '../../../redux/actions';
import {
  GetTeams,
  GetInitiativeDetailsByIdV2,
  UpdateLaunchedInitiative,
} from '../../../redux/constants/apiConstants';
import { DateCalendarWrapper } from '../../ChallengeDetailsV2/StartChallengePopUp/styles';
import { DateCard } from '../../ChallengeCreationAdmin/ActivityChallengeLaunch/style';
import CustomDateTimePicker from '../../common/DateRangePicker/CustomDateTimePicker';

const POINTS = [
  { key: '0', Value: '0', id: '6' },
  { key: '25', Value: '25', id: '1' },
  { key: '50', Value: '50', id: '2' },
  { key: '100', Value: '100', id: '3' },
  { key: '150', Value: '150', id: '4' },
  { key: '200', Value: '200', id: '5' },
  { key: '250', Value: '250', id: '7' },
  { key: '300', Value: '300', id: '8' },
  { key: '350', Value: '350', id: '9' },
  { key: '400', Value: '400', id: '10' },
  { key: '450', Value: '450', id: '11' },
  { key: '500', Value: '500', id: '12' },
  { key: '550', Value: '550', id: '13' },
  { key: '600', Value: '600', id: '14' },
  { key: '650', Value: '650', id: '15' },
  { key: '700', Value: '700', id: '16' },
  { key: '750', Value: '750', id: '17' },
  { key: '800', Value: '800', id: '18' },
  { key: '850', Value: '850', id: '19' },
  { key: '900', Value: '900', id: '20' },
  { key: '950', Value: '950', id: '21' },
  { key: '1000', Value: '1000', id: '22' },
];

const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

const disabledRadioStyle = {
  border: '1px solid var(--Bg-Color-for-Light-theme-200, #BDBDBD)',
  background: 'var(--Bg-Color-for-Light-theme-400, #EFEFEF)',
};

class EditCompanyInitiative extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      saving: false,
      step: 1,
      initiativeData: null,
      // Editable
      description: '',
      value: null,
      isUploadDoc: false,
      endDate: null,
      selectedMonths: [],
      departments: [],
      city_location: [],
      teams: [],
      isSpouse: false,
      isDependent: false,
      datePopup: "",
      showDatePopupModal: false,
      time_zone: null,
      // Locked originals (can't unselect)
      originalMonths: [],
      originalDepartments: [],
      originalLocations: [],
      originalTeams: [],
      // Locked display
      usersToInvite: 0,
      recurringType: 'one_time',
      launch: 0,
      startDate: null,
      startedAlready: false,
      // Thumbnail
      initiativeImage: null,
      initiativeImageName: '',
      // UI
      so: false,
      defaultTz: '',
      allTeams: [],
      menuIsOpen: false,
    };
  }

  componentDidMount() {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const normalized = tz === 'Asia/Calcutta' ? 'Asia/Kolkata' : tz;
    this.setState({ time_zone: normalized, defaultTz: normalized });
    this.fetchInitiativeDetails();
    const { getCompanyDepartment, companyInfo } = this.props;
    if (companyInfo?.id) {
      getCompanyDepartment(companyInfo.id);
      this.props.getCompanyLocation(companyInfo.id);
      this.fetchTeams(companyInfo.id);
    }
  }

  getInitiativeData = () =>
    this.props.history?.location?.state?.initiativeData || {};

  fetchInitiativeDetails = async () => {
    const nav = this.getInitiativeData();
    const initiativeId = nav?.initiative_id || nav?.id;
    if (!initiativeId) { this.setState({ loading: false }); return; }

    const { companyInfo } = this.props;
    try {
      const res = await fetchApi(GetInitiativeDetailsByIdV2, 'POST', {
        company_id: companyInfo?.id,
        initiative_id: initiativeId,
        start_date: nav?.start_date || nav?.launch_date || '',
        end_date: nav?.end_date || '',
      });

      if (res.status === 'success') {
        const raw = res.data;
        const d = Array.isArray(raw) ? raw[0] : raw;

        const startDateStr = d?.start_date || d?.launch_date || nav?.start_date || nav?.launch_date;
        const endDateStr = d?.end_date || nav?.end_date;
        const startedAlready = startDateStr ? new Date(startDateStr) <= new Date() : false;

        const inviteMap = { all_company_users: 0, departments: 1, locations: 2, teams: 3 };
        const months = Array.isArray(d?.recurring_months)
          ? d.recurring_months.map((m) => m - 1)
          : [];
        const depts = Array.isArray(d?.departments) ? d.departments.map((x) => x.id || x) : [];
        const locs = Array.isArray(d?.city_states)
          ? d.city_states.map((x) => x.id || x)
          : Array.isArray(d?.locations)
            ? d.locations.map((x) => x.id || x)
            : [];
        const teams = Array.isArray(d?.teams) ? d.teams.map((x) => x.id || x) : [];

        this.setState({
          loading: false,
          initiativeData: { ...nav, ...d },
          description: d?.about || d?.description || '',
          value: String(d?.point_value ?? d?.points ?? nav?.point_value ?? ''),
          isUploadDoc: !!d?.is_document_required,
          endDate: endDateStr ? dayjs(endDateStr) : null,
          startDate: startDateStr ? dayjs(startDateStr) : null,
          startedAlready,
          time_zone: d?.timezone || nav?.timezone || this.state.time_zone,
          recurringType: d?.is_recurring ? 'recurring' : 'one_time',
          launch: d?.is_upcoming ? 1 : 0,
          usersToInvite: inviteMap[d?.initiative_for] ?? 0,
          selectedMonths: months,
          originalMonths: [...months],
          departments: depts,
          originalDepartments: [...depts],
          city_location: locs,
          originalLocations: [...locs],
          teams: teams,
          originalTeams: [...teams],
          isSpouse: !!d?.is_for_spouse,
          isDependent: !!d?.is_for_dependent,
          initiativeImage: d?.thumbnail || nav?.thumbnail || null,
        });
      } else {
        toast.error(res.message || 'Failed to fetch initiative details');
        this.setState({ loading: false });
      }
    } catch (err) {
      toast.error(err.message);
      this.setState({ loading: false });
    }
  };

  fetchTeams = async (companyId) => {
    try {
      const res = await fetchApi(`${GetTeams}/${companyId}`, 'GET');
      const teams = res.status === 'success' ? (res.data || []) : [];
      if (teams.length) this.setState({ allTeams: teams });
    } catch { /* silent */ }
  };

  // Months: can only add new ones, cannot unselect original ones
  toggleMonth = (index) => {
    const { selectedMonths, originalMonths } = this.state;
    if (originalMonths.includes(index)) return; // locked
    if (selectedMonths.includes(index)) {
      this.setState({ selectedMonths: selectedMonths.filter((m) => m !== index) });
    } else {
      this.setState({ selectedMonths: [...selectedMonths, index] });
    }
  };

  // Departments: can only add, cannot remove originals
  toggleDepartment = (id) => {
    const { departments, originalDepartments } = this.state;
    if (originalDepartments.includes(id)) return;
    if (departments.includes(id)) {
      this.setState({ departments: departments.filter((d) => d !== id) });
    } else {
      this.setState({ departments: [...departments, id] });
    }
  };

  // Locations: can only add, cannot remove originals
  toggleLocation = (id) => {
    const { city_location, originalLocations } = this.state;
    if (originalLocations.includes(id)) return;
    if (city_location.includes(id)) {
      this.setState({ city_location: city_location.filter((l) => l !== id) });
    } else {
      this.setState({ city_location: [...city_location, id] });
    }
  };

  // Teams: can only add, cannot remove originals
  toggleTeam = (id) => {
    const { teams, originalTeams } = this.state;
    if (originalTeams.includes(id)) return;
    if (teams.includes(id)) {
      this.setState({ teams: teams.filter((t) => t !== id) });
    } else {
      this.setState({ teams: [...teams, id] });
    }
  };

  onInitiativeImageChange = (imgSrc, imageName) => {
    this.setState({ initiativeImage: imgSrc, initiativeImageName: imageName });
  };

  onInitiativeImageRemove = () => {
    this.setState({ initiativeImage: null, initiativeImageName: '' });
  };

  onChangeDescription = (evt) => {
    const newContent = evt.getData();
    const trimmed = newContent.replace(/\s|&nbsp;/g, '');
    this.setState({
      description:
        trimmed.length === 0 || trimmed === '<p></p><p></p>' ? '' : newContent,
    });
  };

  saveEdit = async () => {
    const {
      description, value, isUploadDoc, endDate, startDate,
      selectedMonths, departments, city_location, teams,
      isSpouse, isDependent, time_zone, recurringType, launch,
      initiativeImage, usersToInvite
    } = this.state;
    const { companyInfo } = this.props;
    const initiativeData = this.getInitiativeData();
    const cid = initiativeData?.company_initiative_id || initiativeData?.id;

    if (!value) { toast.error('Please select a point value'); return; }
    if (!endDate) { toast.error('Please select an end date'); return; }

    this.setState({ saving: true });


    let initiative_for = "all_company_users";
    if (usersToInvite === 1) {
      initiative_for = "departments";
    } else if (usersToInvite === 2) {
      initiative_for = "locations";
    } else if (usersToInvite === 3) {
      initiative_for = "teams";
    }

    const payload = {
      company_id: companyInfo?.id,
      company_initiative_id: cid,
      initiative_id: initiativeData?.initiative_id || initiativeData?.id,
      is_upcoming: launch,
      point_value: value,
      launch_date: startDate ? dayjs(startDate).format('YYYY-MM-DD') : undefined,
      end_date: dayjs(endDate).format('YYYY-MM-DD HH:mm:ss'),
      about: description,
      timezone: time_zone,
      is_document_required: isUploadDoc ? 1 : 0,
      departments: departments.length ? departments : null,
      city_states: city_location.length ? city_location : null,
      teams: teams.length ? teams : null,
      is_for_spouse: isSpouse ? 1 : 0,
      is_for_dependent: isDependent ? 1 : 0,
      is_recurring: recurringType === 'recurring' ? 1 : 0,
      recurring_months: selectedMonths.map((m) => m + 1),
      thumbnail: initiativeImage || null,
      initiative_for: initiative_for,
    };

    try {
      const res = await fetchApi(UpdateLaunchedInitiative, 'PUT', payload);
      if (res.status === 'success' || res.message === 'Initiative updated successfully') {
        toast.success('Initiative updated successfully');
        this.props.history.goBack();
      } else {
        toast.error(res.message || res.error || 'Failed to update initiative');
        this.setState({ saving: false });
      }
    } catch (err) {
      toast.error(err.message);
      this.setState({ saving: false });
    }
  };

  updateStep = (step) => {
    this.setState({ step });
    window.scrollTo(0, 0);
  };

  DropdownIndicator = () => (
    <div>{NewDropDownIcon(this.props.brandingColor)}</div>
  );

  renderHeading = () => {
    // const { initiativeData } = this.state;
    window.console.log("hii")
    return (
      <Heading color="#184A61">
        <div
          className="close-icon"
          onClick={() => this.props.history.goBack()}
        >
          <ManagerIconContainer isWidth="34px">{RecognitionCloseIcon('#DA6C74')}</ManagerIconContainer>
        </div>
        Edit Health Initiative
        {/* {initiativeData?.initiative_name
          ? ` — ${initiativeData.initiative_name}`
          : ''} */}
      </Heading>
    );
  };

  // ─── Step 1: Title (locked) + Icon (locked) + Description (editable) ────────
  stepOneForm = () => {
    const { description, step, initiativeData, initiativeImage } = this.state;
    const { history } = this.props;
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container stepBackground="#85C0EA" color="#184A61">
            <div className="stepsNameHighlight">
              <StepNames stepCount={step} type="edit-initiative" />
            </div>
            <div className="form">
              <div className="formBody">
                <InputContainer>
                  <StyledLabel style={{ marginTop: '0px' }} color="#184A61">
                    Title of the health initiative <span>*</span>
                  </StyledLabel>
                  <StyledInputV2
                    value={initiativeData?.initiative_name || history?.location?.state?.initiativeData?.initiative_name || ''}
                    disabled
                    bgColor="EFEFEF"
                    border="1px solid #BDBDBD"
                    color="#BDBDBD"
                    pColor="#649bb3"
                  />
                </InputContainer>

                <Border style={{ background: '#EFEFEF', margin: '20px 0 0 0', display: 'flex' }} />

                <div style={{ display: 'flex', width: '50%', gap: '40px', margin: '20px 0' }}>
                  <div style={{ paddingRight: '40px', borderRight: '1px solid #efefef' }}>
                    <InputContainer>
                      <StyledLabel isFont="14px" color="#184A61" margin="0" marginb="0">
                        Initiative Image 
                        <span style={{ color: '#BDBDBD', fontFamily: 'lato', fontSize: '12px',marginLeft:'4px' }}>
                          {" "} (Size limit up to 2 MB)
                        </span>
                        <span style={{ color: "#DA6C74" }}>*</span>
                      </StyledLabel>
                      <CommonImageUploader
                        imgSrc={checkBase64(initiativeImage) ? initiativeImage : initiativeImage ? ImageUrl + '/' + initiativeImage : null}
                        onImageChange={this.onInitiativeImageChange}
                        onRemoveImage={this.onInitiativeImageRemove}
                        ImageType="(.jpeg, .png, .jpg)"
                        accept=".jpeg, .png, .jpg"
                        t={this.props.t}
                        margin="0"
                        maxSizeMB={2}
                      />
                    </InputContainer>
                  </div>
                  <InputContainer style={{ minWidth: '28%', alignItems: 'center' }} margin>
                    <StyledLabel isFont="14px" color="#184A61" margin="-40px">
                      Initiative icon <span style={{ color: '#DA6C74' }}>*</span>
                    </StyledLabel>
                    <InitiativeIcon
                      background={initiativeData?.color || history?.location?.state?.initiativeData?.color || '#BE7D9C'}
                    >
                      <LazyImage
                        style={{ width: '36px', height: '36px' }}
                        div="image"
                        src={ImageUrl + '/' + (initiativeData?.initiative_white_icon || history?.location?.state?.initiativeData?.initiative_white_icon)}
                      />
                    </InitiativeIcon>
                  </InputContainer>
                </div>

                <Border style={{ background: '#EFEFEF', margin: '0 0 0 0', display: 'flex' }} />

                <InputContainer>
                  <StyledLabel color="#184A61">About the health initiative</StyledLabel>
                  <EditorContainer>
                    <Editor content={description} onChange={this.onChangeDescription} />
                  </EditorContainer>
                </InputContainer>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  // ─── Step 2: Points (editable) + Documentation/Initiative Creation (editable) ─
  stepTwoForm = () => {
    const { step, value, isUploadDoc, so } = this.state;
    const initiativeId = this.getInitiativeData()?.id || this.getInitiativeData()?.initiative_id;
    const showDoc = initiativeId !== 1 && initiativeId !== 2;
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color="#184A61" stepBackground="#85c0ea">
            <div className="stepsNameHighlight">
              <StepNames stepCount={step} type="edit-initiative" />
            </div>
            <div className="form">
              <div className="formBody" style={{ minHeight: '305px' }}>
                <CommonDropdown
                  tileContainerStyle={{ width: '100%', padding: '0px' }}
                  dropdownStyle={{ top: '90px' }}
                  labelText="Health Initiative point"
                  isRequired
                  dropdownOpen={so}
                  placeholder="Select Point Value"
                  title={value}
                  id="dropdown-points"
                  onClick={() => this.setState({ so: !so })}
                  data={POINTS}
                  onSelect={(list) => this.setState({ value: list.key, so: false })}
                  active={value}
                  onSelectParameter={['value', 'Value', 'key']}
                  valueString=""
                  itemValue
                  valueIndex={1}
                  labelMargin="0px"
                  dropIcon
                />

                {showDoc && (
                  <>
                    <Border style={{ background: '#EFEFEF', margin: '40px 0 0 0', display: 'flex', position: 'relative', top: '8px' }} />
                    <StyledLabel color="#184A61">
                      Would you like users to upload documentation proving they completed this initiative? <span>*</span>
                    </StyledLabel>
                    <Locationwrapper background="white">
                      <div className="checkBoxWidth" style={{ width: '10.33%' }}>
                        <span style={{ color: '#184A61' }}>
                          <CustomRadioButton
                            onClick={() => this.setState({ isUploadDoc: true })}
                            background="#afcbd3"
                            width="20px"
                            height="20px"
                            className="parentRadioBtn"
                          >
                            {isUploadDoc && <span className="selected" />}
                          </CustomRadioButton>
                          Yes
                        </span>
                      </div>
                      <div className="checkBoxWidth">
                        <span style={{ color: '#092F41' }}>
                          <CustomRadioButton
                            onClick={() => this.setState({ isUploadDoc: false })}
                            width="20px"
                            height="20px"
                            className="parentRadioBtn"
                          >
                            {!isUploadDoc && <span className="selected" />}
                          </CustomRadioButton>
                          No
                        </span>
                      </div>
                    </Locationwrapper>
                  </>
                )}
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  // ─── Step 3: Invite Users (type locked, sub-options addable only) ─────────────
  stepThreeForm = () => {
    const {
      step, usersToInvite, departments, originalDepartments,
      city_location, originalLocations, teams, originalTeams,
      isSpouse, isDependent,
    } = this.state;
    const { locationDetails, departmentDetails, companyDetails, role } = this.props;
    const allTeamsData = this.state.allTeams;

    const typeLabels = ['All Users', 'Departments', 'Locations', 'Teams'];

    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color="#184A61">
            <div className="stepsNameHighlight">
              <StepNames stepCount={step} type="edit-initiative" />
            </div>
            <div className="form">
              <div className="formBody">
                {/* User type — LOCKED (display only) */}
                <div className="name" style={{ color: '#184A61', marginBottom: '16px' }}>
                  Who would you like to invite?
                </div>
                <Locationwrapper background="#F8F8F8" style={{ pointerEvents: 'none' }}>
                  {typeLabels.map((label, i) => (
                    <div className="checkBoxWidth" key={i} style={{ width: '20.33%', marginBottom: '0px' }}>
                      <span style={{ color: '#092F41' }}>
                        <CustomRadioButtonV1
                          width="20px"
                          height="20px"
                          className="parentRadioBtn"
                          style={disabledRadioStyle}
                        >
                          {usersToInvite === i && <span className="selected" />}
                        </CustomRadioButtonV1>
                        {label}
                      </span>
                    </div>
                  ))}
                </Locationwrapper>

                {usersToInvite !== 0 && (
                  <Border style={{ background: '#EFEFEF', margin: '8px 0 0 0', display: 'flex' }} />
                )}

                {/* Locations */}
                {usersToInvite === 2 && locationDetails?.length > 0 && (
                  <>
                    <div className="name" style={{ color: '#184A61', marginTop: '12px' }}>
                      Select Locations <span className="global-star">*</span>
                    </div>
                    <Locationwrapper background="white">
                      {locationDetails.map((loc) => {
                        const isOriginal = originalLocations.includes(loc.id);
                        const isSelected = city_location.includes(loc.id);
                        return (
                          <div className="checkBoxWidth" key={loc.id}>
                            <span style={{ color: '#092F41' }}>
                              <ManagerIconContainer selected={isSelected} style={isOriginal ? { opacity: 0.6, pointerEvents: 'none' } : {}}>
                                <div
                                  className="archive-action"
                                  onClick={() => this.toggleLocation(loc.id)}
                                >
                                  {isSelected ? RecognitionTickIcon() : null}
                                </div>
                              </ManagerIconContainer>
                              {loc.location}
                            </span>
                          </div>
                        );
                      })}
                    </Locationwrapper>
                  </>
                )}

                {/* Departments */}
                {usersToInvite === 1 && departmentDetails?.length > 0 && (
                  <>
                    <div className="name" style={{ color: '#184A61', marginTop: '12px' }}>
                      Select Departments <span className="global-star">*</span>
                    </div>
                    <Locationwrapper background="white">
                      {departmentDetails.map((dep) => {
                        const isOriginal = originalDepartments.includes(dep.id);
                        const isSelected = departments.includes(dep.id);
                        return (
                          <div className="checkBoxWidth" key={dep.id}>
                            <span style={{ color: '#092F41' }}>
                              <ManagerIconContainer selected={isSelected} style={isOriginal ? { opacity: 0.6, pointerEvents: 'none' } : {}}>
                                <div
                                  className="archive-action"
                                  onClick={() => this.toggleDepartment(dep.id)}
                                >
                                  {isSelected ? RecognitionTickIcon() : null}
                                </div>
                              </ManagerIconContainer>
                              {dep.department}
                            </span>
                          </div>
                        );
                      })}
                    </Locationwrapper>
                  </>
                )}

                {/* Teams */}
                {usersToInvite === 3 && Array.isArray(allTeamsData) && allTeamsData.length > 0 && (
                  <>
                    <div className="name" style={{ color: '#184A61', marginTop: '12px' }}>
                      Select Teams <span className="global-star">*</span>
                    </div>
                    <Locationwrapper background="white">
                      {allTeamsData.map((team) => {
                        const isOriginal = originalTeams.includes(team.id);
                        const isSelected = teams.includes(team.id);
                        return (
                          <div className="checkBoxWidth" key={team.id}>
                            <span style={{ color: '#092F41' }}>
                              <ManagerIconContainer selected={isSelected} style={isOriginal ? { opacity: 0.6, pointerEvents: 'none' } : {}}>
                                <div
                                  className="archive-action"
                                  onClick={() => this.toggleTeam(team.id)}
                                >
                                  {isSelected ? RecognitionTickIcon() : null}
                                </div>
                              </ManagerIconContainer>
                              {team.name}
                            </span>
                          </div>
                        );
                      })}
                    </Locationwrapper>
                  </>
                )}

                <Border style={{ background: '#EFEFEF', margin: '8px 0 0 0', display: 'flex' }} />

                {/* Spouse / Dependent */}
                {companyDetails?.['spouse_or_dependent'] && (
                  <div>
                    <StyledLabel color="#184A61" style={{ marginTop: '10px' }}>
                      Are you also interested in extending an invitation?
                    </StyledLabel>
                    <Locationwrapper background="white" style={{ marginTop: '0px' }}>
                      <div className="checkBoxWidth" style={{ width: '16%' }}>
                        <span style={{ color: '#184A61' }}>
                          <ManagerIconContainer selected={isSpouse}>
                            <div
                              className="archive-action"
                              onClick={() => this.setState((p) => ({ isSpouse: !p.isSpouse }))}
                            >
                              {isSpouse ? RecognitionTickIcon() : null}
                            </div>
                          </ManagerIconContainer>
                          Spouse
                        </span>
                      </div>
                      {role !== 'ADMIN' && (
                        <div className="checkBoxWidth" style={{ width: '16%' }}>
                          <span style={{ color: '#092F41' }}>
                            <ManagerIconContainer selected={isDependent}>
                              <div
                                className="archive-action"
                                onClick={() => this.setState((p) => ({ isDependent: !p.isDependent }))}
                              >
                                {isDependent ? RecognitionTickIcon() : null}
                              </div>
                            </ManagerIconContainer>
                            Dependent
                          </span>
                        </div>
                      )}
                    </Locationwrapper>
                  </div>
                )}
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };



  hideShowCalendarPopup = (value) => {
    this.setState({
      datePopup: value,
      showDatePopupModal: true,
    });
  };
  
  hideCalendarPopup = () => {
    this.setState({
      showDatePopupModal: false,
      datePopup: "",
    });
  };


  onChangeDateValue = (date, stateName) => {
    this.setState({ [stateName]: dayjs(date), showDatePopupModal: false });
  };

  // ─── Step 4: Launch/Schedule (locked) + Timezone + Recurring/Date (restricted) ─
  stepFourForm = () => {
    const {
      step, launch, recurringType, selectedMonths, originalMonths,
      time_zone, defaultTz, endDate, startDate,showDatePopupModal,   datePopup
    } = this.state;

    const isRecurring = recurringType === 'recurring';
    const customStyles = {
      control: (base, state) => ({
        ...base,
        boxShadow: null,
        '&:hover': { borderColor: state.isFocused ? 'hsl(0,0%,70%)' : 'hsl(0,0%,70%)' },
      }),
    };
    let timeZoneLabel = '';
    timezones['timezones'].forEach((z) => {
      if (z.value === time_zone) timeZoneLabel = z.label;
    });

    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color="#184A61">
            <div className="stepsNameHighlight">
              <StepNames stepCount={step} type="edit-initiative" />
            </div>
            <div className="form">
              <div className="formBody">

                {/* Launch/Schedule — LOCKED */}
                <StyledLabel color="#184A61" style={{ marginTop: '0px' }}>
                  When would you like to launch initiative? <span>*</span>
                </StyledLabel>
                <Locationwrapper background="#F8F8F8" style={{ pointerEvents: 'none' }}>
                  <div className="checkBoxWidth" style={{ width: '20.33%' }}>
                    <span style={{ color: '#092F41' }}>
                      <CustomRadioButtonV1 width="20px" height="20px" className="parentRadioBtn" style={disabledRadioStyle}>
                        {launch === 0 && <span className="selected" />}
                      </CustomRadioButtonV1>
                      Launch now
                    </span>
                  </div>
                  <div className="checkBoxWidth" style={{ width: '20.33%' }}>
                    <span style={{ color: '#092F41' }}>
                      <CustomRadioButtonV1 width="20px" height="20px" className="parentRadioBtn" style={disabledRadioStyle}>
                        {launch === 1 && <span className="selected" />}
                      </CustomRadioButtonV1>
                      Schedule for later
                    </span>
                  </div>
                </Locationwrapper>

                <Border style={{ background: '#EFEFEF', margin: '8px 0 0 0', display: 'flex' }} />

                {/* Timezone */}
                <TitleContainer fullWidth margin="0 0 20px 0" style={{ padding: '0px' }}>
                  <StyledLabel color="#184A61" style={{ marginTop: '20px' }}>
                    What is your preferred time zone? <span>*</span>
                  </StyledLabel>
                  <SearchDropDown
                    pcolor={time_zone ? '#184A61' : '#184A61'}
                    pfont={time_zone ? 'rubik-medium' : 'rubik'}
                    style={{ height: '50px', width: '100%' }}
                  >
                    <Select
                      defaultValue={
                        time_zone
                          ? timeZoneLabel + (defaultTz === time_zone ? ' (System default)' : '')
                          : 'Select Timezone'
                      }
                      options={timezones['timezones']}
                      onChange={(opt) => this.setState({ time_zone: opt.value })}
                      classNamePrefix="menu-item"
                      styles={customStyles}
                      components={{ DropdownIndicator: this.DropdownIndicator }}
                      placeholder={
                        time_zone
                          ? timeZoneLabel + (defaultTz === time_zone ? ' (System default)' : '')
                          : 'Select Timezone'
                      }
                    />
                  </SearchDropDown>
                </TitleContainer>

                <Border style={{ background: '#EFEFEF', margin: '8px 0 8px 0', display: 'flex' }} />

                {/* Duration — LOCKED */}
                <StyledLabel color="#184A61" style={{ marginTop: '0px' }}>
                  How long should this initiative run? <span>*</span>
                </StyledLabel>
                <Locationwrapper background="#F8F8F8" style={{ pointerEvents: 'none' }}>
                  <div className="checkBoxWidth" style={{ width: '20.33%' }}>
                    <span style={{ color: '#092F41' }}>
                      <CustomRadioButtonV1 width="20px" height="20px" className="parentRadioBtn" style={disabledRadioStyle}>
                        {recurringType === 'one_time' && <span className="selected" />}
                      </CustomRadioButtonV1>
                      One time
                    </span>
                  </div>
                  <div className="checkBoxWidth" style={{ width: '20.33%' }}>
                    <span style={{ color: '#092F41' }}>
                      <CustomRadioButtonV1 width="20px" height="20px" className="parentRadioBtn" style={disabledRadioStyle}>
                        {recurringType === 'recurring' && <span className="selected" />}
                      </CustomRadioButtonV1>
                      Recurring
                    </span>
                  </div>
                </Locationwrapper>

                {/* Recurring months — addable only */}
                {isRecurring && (
                  <div>
                    <StyledLabel style={{ color: '#184A61', marginTop: '0' }}>
                      Select months below:
                    </StyledLabel>
                    <Locationwrapper background="white" style={{ flexWrap: 'wrap' }}>
                      {MONTH_NAMES.map((name, i) => {
                        const isOriginal = originalMonths.includes(i);
                        const isSelected = selectedMonths.includes(i);
                        return (
                          <div
                            key={i}
                            className="checkBoxWidth"
                            style={{
                              width: 'auto', marginBottom: '10px', marginRight: '12px',
                              borderRadius: '25px', padding: '8px 16px 8px 12px',
                              border: '1px solid #DCDCDC',
                              opacity: isOriginal ? 0.6 : 1,
                              pointerEvents: isOriginal ? 'none' : 'auto',
                            }}
                          >
                            <span style={{ color: '#092F41' }}>
                              <ManagerIconContainer selected={isSelected}>
                                <div
                                  className="archive-action"
                                  onClick={() => this.toggleMonth(i)}
                                >
                                  {isSelected ? RecognitionTickIcon() : null}
                                </div>
                              </ManagerIconContainer>
                              {name}
                            </span>
                          </div>
                        );
                      })}
                    </Locationwrapper>
                    <p style={{ fontFamily: 'lato', margin: '8px 0 0 0', color: '#C06236', fontSize: '14px' }}>
                      This will repeat monthly — Start on 1st date and End on last date of the month
                    </p>
                  </div>
                )}

                {/* Dates */}
                {/* {!isRecurring && (
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <MUICalendarWrapper>
                      <div style={{width:'100%'}}>
                        <StyledLabel color="#184A61" style={{ marginTop: '20px' }}>
                          Start Date
                        </StyledLabel>
                        <DateTimePicker
                          viewRenderers={{ hours: renderTimeViewClock, minutes: renderTimeViewClock }}
                          sx={{ width: '98%', background: '#EFEFEF' }}
                          value={startDate}
                          disabled
                          slots={{ openPickerIcon: NewCalendarIconDisabled }}
                        />
                      </div>
                      <div style={{width:'100%'}}>
                        <StyledLabel color="#184A61" style={{ marginTop: '20px' }}>End Date <span>*</span></StyledLabel>
                        <DateTimePicker
                          viewRenderers={{ hours: renderTimeViewClock, minutes: renderTimeViewClock }}
                          sx={{ width: '100%' }}
                          value={endDate}
                          onChange={(val) => this.setState({ endDate: val })}
                          minDateTime={startDate || dayjs()}
                          slots={{ openPickerIcon: NewCalendarIcon }}
                        />
                      </div>
                    </MUICalendarWrapper>
                  </LocalizationProvider>
                )} */}

                {!isRecurring && (
                  <>
                    <div className="dateCard" style={{ marginTop: "10px", gap: "8px" }}>
                      
                      {/* START DATE */}
                      <DateCalendarWrapper>
                        <StyledLabel color="#184A61" style={{ marginTop: "0px" }}>
                          Start Date
                        </StyledLabel>
                
                        <DateCard
                          background={false}
                          color={false}
                          style={{
                            cursor: "not-allowed",
                            background: "#EFEFEF",
                            opacity: 0.7,
                          }}
                        >
                          {startDate
                            ? dayjs(startDate).format("MM/DD/YYYY | hh:mm A")
                            : "Select start date"}
                
                          {CalendarBranding("#BDBDBD")}
                        </DateCard>
                      </DateCalendarWrapper>
                
                      {/* END DATE */}
                      <DateCalendarWrapper>
                        <StyledLabel color="#184A61" style={{ marginTop: "0px" }}>
                          End Date <span>*</span>
                        </StyledLabel>
                
                        <DateCard
                          color={!endDate}
                          onClick={() => this.hideShowCalendarPopup("endDate")}
                        >
                          {endDate
                            ? dayjs(endDate).format("MM/DD/YYYY | hh:mm A")
                            : "Select end date"}
                
                          {CalendarBranding("#DA6C74")}
                        </DateCard>
                      </DateCalendarWrapper>
                    </div>
                
                    {/* <Border
                      style={{
                        background: "#EFEFEF",
                        margin: "20px 0px 0px 0px",
                        display: "flex",
                      }}
                    /> */}
                  </>
                )}
              </div>
            </div>
          </Container>
        </div>

        {showDatePopupModal && (
          <CustomDateTimePicker
            showModal={showDatePopupModal}
            onClose={this.hideCalendarPopup}
            date={datePopup === "date" ? startDate : endDate}
            stateDateSelected={
              datePopup === "date"
                ? dayjs(new Date())
                : startDate
            }
            changeDate={this.onChangeDateValue}
            type={datePopup}
          />
        )}
      </Layout>
    );
  };

  render() {
    const { loading, saving, step, initiativeImage } = this.state;

    window.console.log("initiativeImage",initiativeImage)

    if (loading) {
      return (
        <Layout>
          <div className="main" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '300px' }}>
            <p style={{ color: '#184A61', fontFamily: 'Lato', fontSize: '16px' }}>Loading...</p>
          </div>
        </Layout>
      );
    }

    return (
      <React.Fragment>
        {step === 1
          ? this.stepOneForm()
          : step === 2
            ? this.stepTwoForm()
            : step === 3
              ? this.stepThreeForm()
              : this.stepFourForm()}

        {step === 1 && (
          <ButtonContainer>
            <Main>
              <CommonButtonPopup
                height="48px" width="200px" margin="auto 0 auto auto"
                // background="#DA6C74"
                onClick={() => this.updateStep(2)}
                disabled={this.state.initiativeImage == null || this.state.description === null}

              >
                Next
              </CommonButtonPopup>
            </Main>
          </ButtonContainer>
        )}

        {step === 2 && (
          <ButtonContainer>
            <div className="wrapper">
              <CommonButton
                btnType="squareIcon"
                styles={{ color: 'white', marginRight: '8px', textColor: '#184A61', padding: '16px 20px', height: '48px', border: '#DA6C74', width: '200px', marginLeft: '0px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                onClick={() => this.updateStep(1)}
                title="Back"
              />
              <CommonButtonPopup
                height="48px" width="200px" margin="auto 0 auto auto"
                // background="#DA6C74"
                disabled={this.state.value === null}
                onClick={() => this.updateStep(3)}
              >
                Next
              </CommonButtonPopup>
            </div>
          </ButtonContainer>
        )}

        {step === 3 && (
          <ButtonContainer>
            <div className="wrapper">
              <CommonButton
                btnType="squareIcon"
                styles={{ color: 'white', marginRight: '8px', textColor: '#184A61', padding: '16px 20px', height: '48px', border: '#DA6C74', width: '200px', marginLeft: '0px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                onClick={() => this.updateStep(2)}
                title="Back"
              />
              <CommonButtonPopup
                height="48px" width="200px" margin="auto 0 auto auto"
                // background="#DA6C74"
                onClick={() => this.updateStep(4)}
              >
                Next
              </CommonButtonPopup>
            </div>
          </ButtonContainer>
        )}

        {step === 4 && (
          <ButtonContainer>
            <div className="wrapper">
              <CommonButton
                btnType="squareIcon"
                styles={{ color: 'white', marginRight: '8px', textColor: '#184A61', padding: '16px 20px', height: '48px', border: '#DA6C74', width: '200px', marginLeft: '0px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                onClick={() => this.updateStep(3)}
                title="Back"
              />
              <CommonButtonPopup
                height="48px" width="200px" margin="auto 0 auto auto"
                // background="#DA6C74"
                disabled={saving || !this.state.endDate}
                onClick={!saving ? this.saveEdit : undefined}
              >
                {saving ? 'Saving...' : 'Save Changes'}
              </CommonButtonPopup>
            </div>
          </ButtonContainer>
        )}
      </React.Fragment>
    );
  }
}

EditCompanyInitiative.propTypes = {
  history: PropTypes.object.isRequired,
  companyInfo: PropTypes.object,
  locationDetails: PropTypes.array,
  departmentDetails: PropTypes.array,
  companyDetails: PropTypes.object,
  role: PropTypes.string,
  brandingColor: PropTypes.string,
  getCompanyLocation: PropTypes.func,
  getCompanyDepartment: PropTypes.func,
  t: PropTypes.func,
};

const mapStateToProps = (state) => ({
  companyInfo: state.companyDashboard.companyInfo,
  locationDetails: state.register.locationDetails,
  departmentDetails: state.register.departmentDetails,
  companyDetails: state.profileData.companyDetails,
  role: state.auth?.role,
  brandingColor: state.wellnessDashboard.brandingColor,
});

const mapDispatchToProps = (dispatch) => ({
  getCompanyLocation: (id) => dispatch(getCompanyLocation(id)),
  getCompanyDepartment: (id) => dispatch(getCompanyDepartment(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withTranslation()(EditCompanyInitiative)
);
